"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
var JUSTIFY_CONTENT = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
    apart: 'space-between',
};
exports.default = react_jss_1.createUseStyles({
    elementsGroup: function (_a) {
        var spacing = _a.spacing, position = _a.position, noWrap = _a.noWrap, theme = _a.theme;
        return ({
            display: 'flex',
            alignItems: 'center',
            flexWrap: noWrap ? 'nowrap' : 'wrap',
            justifyContent: JUSTIFY_CONTENT[position],
            margin: (-1 * theme_1.getSizeValue({ size: spacing, sizes: theme.spacing })) / 2,
        });
    },
    child: function (_a) {
        var grow = _a.grow, spacing = _a.spacing, theme = _a.theme;
        return ({
            flexGrow: grow ? 1 : 0,
            margin: theme_1.getSizeValue({ size: spacing, sizes: theme.spacing }) / 2,
        });
    },
}, { link: true });
